(function() {
	'use strict';
	var
		collapseCompBox = document.querySelectorAll('.media-body .collapse-btn'),
		collapseCompTable = document.querySelector('#collapse-media-1'),
		scrollToTarget = function(button){
			button.addEventListener("click",function(e) {
				document.querySelector(e.currentTarget.getAttribute('data-bs-target')).scrollIntoView();
			});
		};

	collapseCompBox.forEach(function(button){
		scrollToTarget(button);
	});

	scrollToTarget(collapseCompTable);
})();
